module.exports = __webpack_public_path__ + "static/media/submitorder.88c93590.mp3";